import { ComponentProps } from 'react'
import Link from 'next/link'
import { serverRedirect } from '../_actions/server-redirect'

/**
 * Renders either a Next.js `Link` component or a button within a form that triggers a server action redirect.
 * This allows bypassing Next.js route interception when `skipIntercept` is true.
 *
 * For example, this is used on the standalone token page to navigate to another token page
 * without triggering the intercepting route (modal).
 */
export function OptionalInterceptLink(
  props:
    | ({ skipIntercept?: false } & ComponentProps<typeof Link>)
    | ({ skipIntercept: true; href: string } & ComponentProps<'button'>)
) {
  if (!props.skipIntercept) {
    return <Link {...props} href={props.href} />
  }

  const { href, skipIntercept, ...rest } = props

  return (
    <form className="contents" action={() => serverRedirect(href)}>
      <button {...rest} type="submit" />
    </form>
  )
}
